import React, { FC } from 'react';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { getSecondsDifference } from './GetSecondsDifference';

interface BillableTimeProps {
  startTime: dayjs.Dayjs;
  startDeduction: dayjs.Dayjs | null;
  endDeduction: dayjs.Dayjs | null;
  endTime: dayjs.Dayjs;
  color?: string;
  size?: number;
}

export const BillableTime: FC<BillableTimeProps> = ({
  startTime,
  startDeduction,
  endDeduction,
  endTime,
  color = 'text.primary',
  size = 14,
}) => {
  // Calculate deduction minutes
  const secondsToDeduct =
    startDeduction && endDeduction
      ? getSecondsDifference(startDeduction.toDate(), endDeduction.toDate())
      : 0;

  // Calculate total billable minutes
  const totalTime = getSecondsDifference(
    startTime.toDate(),
    endTime.toDate()
  );

  // Net billable minutes
  const timeToShow = totalTime - secondsToDeduct;

  // Convert minutes to hours and minutes
  const diffHours = Math.floor(timeToShow / 60);
  const diffMinutes = Math.floor(timeToShow % 60);

  // Format as HH:mm
  const diffHoursStr = diffHours.toString().padStart(2, '0');
  const diffMinutesStr = diffMinutes.toString().padStart(2, '0');
  const diffTimeStr = `${diffHoursStr}:${diffMinutesStr}`;

  return (
    <Typography
      sx={{
        pl: 1,
        pr: 1,
        width: 75,
        fontSize: size,
        letterSpacing: 3,
        textAlign: 'right',
        color,
        fontWeight: 'bold',
      }}
    >
      {diffTimeStr}
    </Typography>
  );
};
